"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTextBetweenMatchingQuotes = void 0;
function getTextBetweenMatchingQuotes(str) {
    for (var i = 0, ch = "", openIdx = -1; i < str.length; i++) {
        ch = str[i];
        if (ch === '"') {
            if (openIdx < 0)
                openIdx = i;
            else
                return str.slice(openIdx + 1, i);
        }
        else if (ch === "\\")
            i++; // grab whatever is next
    }
    return undefined;
}
exports.getTextBetweenMatchingQuotes = getTextBetweenMatchingQuotes;
